import { authModel, AuthModel } from "./auth";
import { DraftModel, draftModel } from "./draft";
import { KindsModel, kindsModel } from "./kinds";
import { utilsModel, UtilsModel } from "./utils";

export type CurrentUserModel = AuthModel & KindsModel & UtilsModel & DraftModel;

export const currentUserModel: CurrentUserModel = {
  ...authModel,
  ...kindsModel,
  ...utilsModel,
  ...draftModel,
};
